import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { useSelector } from 'react-redux';
import store, { loanActions } from '@apply/adminStore';
import DatePicker from 'react-datepicker';
import FileUploader from 'devextreme-react/file-uploader';
import { InsuranceTypeOptions } from '../constants/InsuranceTypeOptions';

const CancelInsuranceModal = () => {
    const { isOpen, id, typeId, onSubmit } = useSelector((state) => state.loan.cancelInsuranceModal);
    const { dispatch } = store;

    const today = new Date().setHours(0, 0, 0, 0);

    const [cancelDate, set_cancelDate] = useState(today);
    const [cancelFiles, set_cancelFiles] = useState([]);

    const maxFileSize = 1024 * 1024 * 5;
    const [canSubmit, set_canSubmit] = useState(false);

    const styles = {
        headerRight: {
            width: '100px',
            position: 'absolute',
            right: '20px',
            paddingTop: '15px',
        },
        buttonContainer: {
            textAlign: 'right',
            borderTop: '2px solid silver',
            padding: '10px 10px',
        },
        sectionHeader: { margin: '10px 0' },
        formColumn: {
            paddingBottom: '5px',
            paddingTop: '10px',
            paddingRight: '0',
        },
        dropzone: {
            width: '100%',
            backgroundColor: 'silver',
            padding: '0px',
        },
    };

    const handleClose = () =>
        dispatch(
            loanActions.setCancelInsuranceModal({
                cancelInsuranceModal: { isOpen: false },
            })
        );

    useEffect(() => {
        set_canSubmit(false);
        set_cancelFiles([]);
        set_cancelDate(today);
    }, [isOpen]);

    useEffect(() => {
        if (cancelDate && cancelFiles && cancelFiles.length > 0) {
            set_canSubmit(true);
        } else {
            set_canSubmit(false);
        }
    }, [cancelFiles, cancelDate]);

    const setCancelDate = (value) => {
        set_cancelDate(value);
    };

    const cancelInsurance = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        onSubmit && onSubmit(id, new Date(cancelDate).toLocaleDateString('en-us'), cancelFiles);

        setTimeout(() => {
            handleClose();
        }, 600);
    };

    const onFilesChanged = (fileArray) => {
        const files = fileArray.filter((file) => file.size <= maxFileSize).slice(0, 4);
        set_cancelFiles(files);
    };

    return (
        <Dialog
            maxWidth='lg'
            open={isOpen}
            onClose={handleClose}
            aria-labelledby='form-dialog-title'
        >
            <div className='modal-container'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    tabIndex='-1'
                    role='dialog'
                    style={{ width: '700px', overflow: 'unset' }}
                >
                    <div
                        className='modal-dialog'
                        role='document'
                    >
                        <div
                            className='page-header'
                            role='banner'
                        >
                            <h1
                                style={{
                                    height: '50px',
                                    marginTop: '15px',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                Cancel {InsuranceTypeOptions?.find((i) => i.id === typeId)?.name} Insurance
                            </h1>
                            <button
                                type='button'
                                className='close'
                                data-dismiss='modal'
                                aria-label='Close'
                                onClick={handleClose}
                            >
                                <span aria-hidden='true'>&times;</span>
                            </button>
                        </div>
                    </div>
                    <div
                        className='main-content no-search'
                        style={{ padding: '0', margin: '0' }}
                    >
                        <form
                            name='editBorrowerForm'
                            onSubmit={(event) => cancelInsurance(event)}
                            className={'standard-form'}
                        >
                            <div
                                className='scrollable-content'
                                style={{
                                    padding: '0 30px 0 20px',
                                    maxHeight: '450px',
                                }}
                            >
                                <div className='row'>
                                    <div
                                        className='columns small-12 large-3'
                                        style={styles.formColumn}
                                    >
                                        <label htmlFor='borrowerEntity'>
                                            Cancellation Date
                                            <span className='req'>*</span>
                                        </label>
                                        <DatePicker
                                            id={'cancelDate'}
                                            selected={cancelDate}
                                            onChange={(event) => setCancelDate(event)}
                                            popperPlacement='bottom'
                                        />
                                    </div>
                                </div>
                                <h2
                                    className='decorated'
                                    style={styles.sectionHeader}
                                >
                                    Files
                                </h2>
                                <div className='row'>
                                    <div
                                        className='columns  small-12 large-12'
                                        style={styles.formColumn}
                                    >
                                        <div style={{ padding: '10px 10px' }}>
                                            <ul>
                                                <li>
                                                    You may select upt to <b>4</b> files. Any others beyond that will NOT be
                                                    uploaded.
                                                </li>
                                                <li>Only pdf, png, jpg and txt file types are allowed</li>
                                                <li>Maximum file size is 5 MB/document</li>
                                            </ul>
                                        </div>
                                        <div
                                            id='drop_zone'
                                            style={styles.dropzone}
                                        >
                                            <FileUploader
                                                selectButtonText='Select Cancellation Files'
                                                labelText='OR drag onto this panel...'
                                                uploadMode='useForm'
                                                maxFileSize={maxFileSize}
                                                invalidFileExtensionMessage='Invalid File Type. File will be ignored'
                                                invalidMaxFileSizeMessage='File too large. File will be ignored'
                                                multiple={true}
                                                allowedFileExtensions={['.pdf', '.png', '.jpg', '.txt']}
                                                allowCanceling={true}
                                                onValueChange={onFilesChanged}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className='button-footer'
                                style={styles.buttonContainer}
                            >
                                <button
                                    style={styles.buttonMarginRight}
                                    type='submit'
                                    className='button primary'
                                    disabled={!canSubmit}
                                    title='Continue with Cancellation and close this window'
                                >
                                    Submit
                                </button>
                                &nbsp;
                                <button
                                    type='button'
                                    className='button hollow'
                                    data-dismiss='modal'
                                    onClick={handleClose}
                                    title='Abandon Cancellation and close this window'
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default CancelInsuranceModal;
